import React, { useState } from 'react';
import { MapPin, Phone, Mail, Check, Send } from 'lucide-react';
import { Button } from '../components/ds/Button';
import { Field } from '../components/ds/Field';
import { PageHero } from '../components/ds/theme';
import notepad from '../assets/images/notepad.jpg';

const INFO = [
  { Icon: MapPin, h: 'Visit Us', p: '4469 Kershaw Camden Hwy, Heath Springs, SC 29058' },
  { Icon: Phone, h: 'Call Us', p: '(803) 273-9220' },
  { Icon: Mail, h: 'Email Us', p: 'blbc@comporium.net' },
];

function Contact() {
  const [sent, setSent] = useState(false);

  return (
    <main>
      <PageHero eyebrow="We'd Love to Hear From You" title="Get In Touch" subtitle="Questions, prayer requests, or planning a visit — reach out." image={notepad} />

      <section className="ds-section-y" style={{ background: 'var(--cream)', padding: 'var(--section-y-sm) var(--gutter)' }}>
        <div className="ds-grid-2" style={{ maxWidth: 'var(--maxw-prose)', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1.1fr', gap: '60px', alignItems: 'start' }}>
          <div>
            <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '36px', fontWeight: 500, color: 'var(--navy-800)', margin: '0 0 16px' }}>Contact Information</h2>
            <p style={{ fontSize: '17px', lineHeight: 1.7, color: 'var(--text-body)', margin: '0 0 32px' }}>Have a question or want to learn more? Reach out using any of the methods below — we respond within a day.</p>
            <div style={{ display: 'grid', gap: '22px' }}>
              {INFO.map((it) => (
                <div key={it.h} style={{ display: 'flex', gap: '18px', alignItems: 'center' }}>
                  <div style={{ width: '56px', height: '56px', flex: 'none', borderRadius: '50%', background: 'var(--gradient-brand)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <it.Icon size={22} />
                  </div>
                  <div>
                    <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '20px', fontWeight: 500, color: 'var(--burgundy-700)', margin: '0 0 2px' }}>{it.h}</h3>
                    <p style={{ fontSize: '16px', color: 'var(--text-body)', margin: 0 }}>{it.p}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ background: 'var(--white)', padding: '38px', borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-md)' }}>
            {sent ? (
              <div style={{ textAlign: 'center', padding: '40px 10px' }}>
                <div style={{ width: '72px', height: '72px', margin: '0 auto 22px', borderRadius: '50%', background: '#e3f0e8', color: 'var(--success)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Check size={36} />
                </div>
                <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '28px', color: 'var(--navy-800)', margin: '0 0 10px', fontWeight: 500 }}>Thank You!</h3>
                <p style={{ fontSize: '16px', color: 'var(--text-body)', lineHeight: 1.7, margin: '0 0 24px' }}>Your message has been received. A member of our team will be in touch soon. God bless you.</p>
                <Button variant="outline" onClick={() => setSent(false)}>Send Another</Button>
              </div>
            ) : (
              <form onSubmit={(e) => { e.preventDefault(); setSent(true); }} style={{ display: 'grid', gap: '18px' }}>
                <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '28px', fontWeight: 500, color: 'var(--navy-800)', margin: '0 0 4px' }}>Send Us a Message</h3>
                <Field label="Your Name" required placeholder="Jane Smith" />
                <Field label="Email Address" type="email" required placeholder="jane@email.com" />
                <Field label="Phone Number" type="tel" placeholder="(803) 555-0100" />
                <Field
                  label="How Can We Help?"
                  as="select"
                  required
                  placeholder="Select a topic"
                  options={['Planning a Visit', 'Prayer Request', 'Ministry Information', 'Giving & Donations']}
                />
                <Field label="Your Message" as="textarea" required placeholder="Tell us how we can help or pray for you…" />
                <Button type="submit" variant="primary" size="lg" fullWidth iconLeft={<Send size={18} />}>Send Message</Button>
              </form>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;
